import React, { useState } from "react"
import PropTypes from "prop-types"
import "../../../../../reuseable-components/MultiSelect/style.css"
import { Button, Col, FormControl, Row } from "react-bootstrap"
import UserOption from "./UserOption"


export default function UserMultiSelect({ users, selectedUsers, setSelectedGroupsFunction, mode="add", transferSelectedUsers, selectAllUsers }) {
  // STATE
  const [searchTerm, setSearchTerm] = useState("")

  const handleClick = (userObject) => {
    let updatedUserList = [...selectedUsers]
    const foundUser = updatedUserList.find(user => user.id === userObject.id)
    if (foundUser) {
      updatedUserList = updatedUserList.filter(user => user.id !== userObject.id)
    } else {
      updatedUserList.push(userObject)
    }
    setSelectedGroupsFunction(updatedUserList)
  }

  return (
    <React.Fragment>
      <FormControl
        value={ searchTerm }
        className="custom-multi-select-option-search"
        onChange={ (e) => setSearchTerm(e.target.value) }
        placeholder="Search"
      />
      <div className="custom-multi-select">
        { users.filter(option => {
          const full_name = `${option.first_name} ${option.last_name}`.toLowerCase();
          return full_name.includes(searchTerm.toLowerCase());
        }).map(userOption => (
          <UserOption
            key={ userOption.id }
            userOption={ userOption }
            onClick={ () => handleClick(userOption) }
            selected={ !!selectedUsers.find(user => user.id === userOption.id) }
          />
        ) )}
      </div>
      <div>
        <Row className="user-multi-select-action-buttons">
          <Col xs={ 4 } md={ 4 } lg={ 4 }>
            <Button onClick={ () => setSelectedGroupsFunction([]) }>Clear</Button>
          </Col>
          <Col xs={ 4 } md={ 4 } lg={ 4 }>
            <Button onClick={ () => selectAllUsers(mode, searchTerm) }>Select All</Button>
          </Col>
          <Col xs={ 4 } md={ 4 } lg={ 4 }>
            <Button onClick={ () => transferSelectedUsers(mode) } bsStyle={ mode==="add" ? "primary" : "danger" }>{ mode === "add" ? "Add" : "Remove" }</Button>
          </Col>
        </Row>



      </div>
    </React.Fragment>
  )
}


UserMultiSelect.propTypes = {
  mode: PropTypes.string,
  users: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  setSelectedGroupsFunction: PropTypes.func.isRequired,
  transferSelectedUsers: PropTypes.func.isRequired,
  selectAllUsers: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/CreateEditFunctionalGroupModal/UserMultiSelect.js